/** A project's releases: the list, making one, the version history, and imported projects. */

export default {
	releases: {
		title: "Releases",
		description:
			"A release is a version of the project that never changes again: built, packaged and tagged in the history. Dataspaces run releases.",
		newRelease: "New release",
		empty: "No releases yet.",
		emptyHint: "Make the first release once the project builds.",
		loadFailed: "The releases could not be loaded.",
		latest: "Latest",
		by: "by {name}",
		notes: "Notes",
		noNotes: "No notes.",
		runBy: "Run by",
		runByNone: "No dataspace runs this version.",
		dataspaceCount: "No dataspaces | {n} dataspace | {n} dataspaces",
		commit: "Commit",
		previous: "Previous version",
		tagged: "Released as {tag}",
		bumpLabel: {
			patch: "Patch",
			minor: "Minor",
			major: "Major",
			custom: "Custom",
		},
		versionHistory: {
			title: "Version history",
			all: "All releases",
			empty: "Nothing has been released yet.",
		},
		create: {
			title: "New release",
			previous: "Previous release: v{version}",
			first: "This is the project's first release.",
			commits: "No changes since then | One change since then | {n} changes since then",
			version: "Version",
			choice: "{bump} — v{version}",
			choiceSuggested: "{bump} — v{version} (suggested)",
			choiceHelp: {
				patch: "Fixes and small changes: nothing added, nothing taken away.",
				minor: "Something was added. Whoever uses the project loses nothing.",
				major: "Something was removed or renamed. Whoever relies on it may break.",
			},
			custom: "Another version",
			customHelp:
				"A semantic version greater than the previous release, such as 1.2.0 or 2.0.0-rc.1.",
			reasons: "Why this version",
			noReasons: "Nothing since the last release calls for more than a patch.",
			ruleLabel: {
				breaking: "Marked breaking",
				removal: "Removal",
				rename: "Rename",
				addition: "Addition",
				change: "Change",
			},
			titleLabel: "Title",
			titleHelp: "Optional. A name for the release, shown beside its version.",
			notesLabel: "Release notes",
			notesHelp:
				"What changed, for whoever runs it. It becomes the body of the release commit.",
			changelog: "Changelog",
			submit: "Release v{version}",
			submitPlain: "Release",
			problem: {
				empty: "Enter a version.",
				invalid: "Not a semantic version. Use the form 1.2.0.",
				notGreater: "Must be greater than v{previous}.",
			},
			progress: {
				preparing: "Preparing the release…",
				waiting: "Waiting for the build that is running to finish…",
				building: "Building v{version}…",
				finishing: "Committing, packaging and tagging v{version}…",
			},
			progressNote:
				"This can take a few minutes. A change to the project made meanwhile means the release has to be made again.",
			created: "Released v{version}.",
			draftFailed: "The next release could not be worked out.",
			buildOutput: "Build output",
		},
		errors: {
			buildFailed: "The build of v{version} failed, so nothing was released.",
			invalidVersion: "“{version}” is not a semantic version. Use the form 1.2.0.",
			notGreater: "v{version} is not greater than the latest release.",
			exists: "v{version} has already been released or built on this server. Choose another version.",
			conflict:
				"The project changed while the release was building, so nothing was released. Make the release again.",
		},
		imported: {
			badge: "Imported — releases only",
			title: "Imported from another server",
			note: "Its releases can run in a dataspace here, but its source is not on this server, so nothing in it can be edited.",
			cardNote:
				"Known here only from its releases. They can run in a dataspace; nothing in it can be edited.",
			versions: "Runnable versions",
			versionsNote: "A dataspace of this project can be set to run any of these.",
			versionsEmpty: "No version of this project can run here.",
		},
	},
};
